<div class="modal-header">
    <h6 class="modal-title pull-left"> {{updateId==''?'Add':'Edit' }} Gate</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">Gate Name</label>
                <input type="text" id="gate" placeholder="Enter Gate Name" class="form-control"
                    [(ngModel)]="addGateObj.gate_name">
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">Event</label>
                <ng-select class="selectpicker selecterchart" [(ngModel)]="addGateObj.org_ref_id" [multiple]="true"
                    (ngModelChange)="onOrgChange($event)">
                    <ng-option value="" disabled="true">Select Event</ng-option>
                    <ng-option *ngFor="let org of orgList; let i = index" [value]="org.id">{{ org.org_name }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">Username</label>
                <input type="text" id="username" placeholder="Enter Username" class="form-control"
                    [(ngModel)]="addGateObj.gate_userName">
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-12">
            <div class="form-group">
                <label for="ID">Password</label>
                <input [type]="password" id="text" placeholder="Enter Gate Password" class="form-control"
                    [(ngModel)]="addGateObj.pass">
            </div>
        </div>
        <!-- <div class="col-md-1 col-sm-1 col-1" style="margin-top: 2.5rem;">
            <div class="form-group" (click)="onClick()">
                <span class="fa fa-eye" aria-hidden="true" *ngIf="!show"></span>
                <span class="fa fa-eye-slash" aria-hidden="true" *ngIf="show"></span>
            </div>
        </div> -->
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Save</button>
</div>